import { Button, Tooltip } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import React from "react";
import "./BulkActionBar.scss";

export interface BulkBarAction {
  key: string;
  icon: React.ReactNode;
  onClick: () => void;
  title?: string;
  loading?: boolean;
  disabled?: boolean;
  className?: string;
}

export interface BulkActionBarProps {
  count: number;
  onCancel: () => void;
  actions: BulkBarAction[];
  /** Force visibility; defaults to `count > 0`. */
  visible?: boolean;
}

export default function BulkActionBar({ count, onCancel, actions, visible }: BulkActionBarProps) {
  const isVisible = visible ?? count > 0;
  return (
    <div className={`bulk-action-bar${isVisible ? " visible" : ""}`}>
      <Tooltip title="Clear selection" placement="top">
        <Button
          type="text"
          className="bulk-close-btn"
          icon={<CloseOutlined />}
          onClick={onCancel}
        />
      </Tooltip>
      <h4>
        {count} item{count === 1 ? "" : "s"} selected
      </h4>
      <div className="bulk-action-bar-actions">
        {actions.map((a) => (
          <Tooltip key={a.key} title={a.title} placement="top">
            <Button
              type="text"
              className={a.className}
              icon={a.icon}
              onClick={a.onClick}
              loading={a.loading}
              disabled={a.disabled}
            />
          </Tooltip>
        ))}
      </div>
    </div>
  );
}
